export default "__VITE_ASSET__CPqaOH0J__"